// dependencies
import { List } from "immutable";

// selectors
import { getUI } from "Selectors/ui";

export const getFileList = (state) => getUI(state).get("fileList", List());
export const getInputValue = (state, name) => getUI(state).getIn(["inputs", name], "");
